import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
import { ButtonClose } from '@shared/ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'IframeModal',
  props: {
    title: { default: 'Опрос' },
    src: { default: 'https://forms.yandex.ru/cloud/6684f8c6e010db9dad5ae676/?page=1' },
    contentClass: { default: '' },
    showCloseButton: { type: Boolean, default: false }
  },
  emits: ['toggleIframeModal'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, src: string, contentClass: string, showCloseButton: boolean }




const isIframeLoading = ref(true)
const isOverlayCloseVisible = computed(() => {
  return props.showCloseButton || props.contentClass.includes('bonus')
})

watch(() => props.src, () => {
  isIframeLoading.value = true
}, { immediate: true })

const onIframeLoad = () => {
  isIframeLoading.value = false
}

const closeModal = () => {
  emit('toggleIframeModal')
}

return { __sfc: true,props, emit, isIframeLoading, isOverlayCloseVisible, onIframeLoad, closeModal, ButtonClose }
}

})